// グローバルメニューの開閉機能
document.addEventListener('DOMContentLoaded', function() {
    const hamburgerBtn = document.getElementById('hamburger-btn');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileMenuItems = document.querySelectorAll('.mobile-menu-item');
    const mobileBreakpoint = window.matchMedia('(max-width: 768px)');
    // ハンバーガーボタンクリックでメニューを開閉（トグル）
    if (hamburgerBtn) hamburgerBtn.addEventListener('click', function() {
        // メニューが開いているかチェック
        const isMenuOpen = mobileMenuOverlay.classList.contains('active');
        if (isMenuOpen) // メニューを閉じる
        closeMenu();
        else {
            // メニューを開く
            hamburgerBtn.classList.add('active');
            mobileMenuOverlay.classList.add('active');
            // スクロールを無効化
            document.body.style.overflow = 'hidden';
        }
    });
    else console.error("\u30CF\u30F3\u30D0\u30FC\u30AC\u30FC\u30DC\u30BF\u30F3\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093");
    // オーバーレイの背景クリックでメニューを閉じる
    if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', function(e) {
        // メニューコンテンツ以外をクリックした場合のみ閉じる
        if (e.target === mobileMenuOverlay) closeMenu();
    });
    // ESCキーでメニューを閉じる
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenuOverlay.classList.contains('active')) closeMenu();
    });
    // メニューを閉じる共通関数
    function closeMenu() {
        if (hamburgerBtn) hamburgerBtn.classList.remove('active');
        if (mobileMenuOverlay) mobileMenuOverlay.classList.remove('active');
        // スクロールを再有効化
        document.body.style.overflow = '';
    }
    // メニューアイテムクリック時の処理（準備中メッセージ表示とメニューを閉じる）
    const allMenuItems = document.querySelectorAll('.menu-item, .mobile-menu-item');
    allMenuItems.forEach(function(item) {
        item.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            // #リンクの場合は準備中メッセージを表示
            if (href === '#') {
                e.preventDefault();
                // モバイルメニューの場合は先にメニューを閉じる
                if (item.classList.contains('mobile-menu-item')) closeMenu();
            }
        });
    });
    // --- Prevent single-character widows on mobile ---
    function preventWidow(element) {
        if (element.dataset.widowApplied === 'true') return;
        // Skip if element contains other elements such as <br> or nested spans
        if (element.childElementCount > 0) return;
        const originalText = element.textContent;
        if (!originalText) return;
        const trimmedText = originalText.trim();
        if ([
            ...trimmedText
        ].length < 3) return;
        const leadingWhitespaceMatch = originalText.match(/^\s+/u);
        const trailingWhitespaceMatch = originalText.match(/\s+$/u);
        const leadingWhitespace = leadingWhitespaceMatch ? leadingWhitespaceMatch[0] : '';
        const trailingWhitespace = trailingWhitespaceMatch ? trailingWhitespaceMatch[0] : '';
        const characters = [
            ...trimmedText
        ];
        const body = characters.slice(0, -2).join('');
        const tail = characters.slice(-2).join('');
        element.textContent = '';
        if (leadingWhitespace) element.append(leadingWhitespace);
        if (body) element.append(body);
        const span = document.createElement('span');
        span.className = 'no-widow';
        span.textContent = tail;
        element.append(span);
        if (trailingWhitespace) element.append(trailingWhitespace);
        element.dataset.widowApplied = 'true';
    }
    function applyWidowPrevention() {
        if (!mobileBreakpoint.matches) return;
        const targetElements = document.querySelectorAll('main p, main li, main dt, main dd');
        targetElements.forEach(preventWidow);
    }
    applyWidowPrevention();
    window.addEventListener('resize', applyWidowPrevention);
    if (typeof mobileBreakpoint.addEventListener === 'function') mobileBreakpoint.addEventListener('change', applyWidowPrevention);
    else if (typeof mobileBreakpoint.addListener === 'function') mobileBreakpoint.addListener(applyWidowPrevention);
});

//# sourceMappingURL=anfini.f2aae410.js.map
